import $ from "jquery";
import { Toast } from "bootstrap";
import React, { useContext, useEffect, useState, Fragment } from "react";
import { WishlistContext, WishlistProvider } from "../../Context/WishlistContext";
import { axiosInstance } from "../../axios/axiosInstance";
import { GlobalContext } from "../../Context/GlobalContext";
import { isValidArray, showFavouriteToaster, showWishListRemoveToaster } from "./common";
import "../../../src/assets/plugins/wesicons/fonts/wescom.svg";
import { Link, useLocation } from "react-router-dom";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { loadScriptDropDown } from "../../View/ProductHybrid/scripts";
import { useRef } from "react";
import { PAGES } from "../../routeConfig";

export const WishlistItem = ({ productId }) => {
  const globalcontext = useContext(GlobalContext);
  const { wishlistState, dispatch } = useContext(WishlistContext);
  const [isAdded, setIsAdded] = useState(wishlistState[productId] || false);
  const [isAnimate, setIsAnimate] = useState(false);
  const [pageName, setPagename] = useState(null);
  const location = useLocation();
  const { handleWishList, addToWishList } = useGlobalFunction();
  const [listItem, setListItem] = useState(null);
  const dropdownRef = useRef(null);
  useEffect(() => {
    setPagename(location.pathname.toUpperCase());
  }, [location.pathname]);

  useEffect(() => {
    if (globalcontext.WishList && globalcontext.WishList.length > 0) {
      var products = globalcontext.WishList;
      var myWishList = products.some((product) => String(product.PRODUCT_ID) == String(productId));
      if (myWishList) {
        dispatch({ type: "ADD_TO_WISHLIST", productId, showAlert: false });
      }
    }
  }, [globalcontext.WishList]);

  useEffect(() => {
    setIsAdded(wishlistState[productId] ?? false);
  }, [wishlistState]);

  const handleWishlistClick = (event) => {
    setIsAnimate(true);
    setTimeout(() => {
      setIsAnimate(false);
    }, 1000);
    var p = $(event.currentTarget);
    if (isAdded) {
      setIsAdded(false);
      handleWishList("REMOVE", productId);
    } else {
      handleWishList("ADD", productId);
      setIsAdded(true);
    }
  };

  useEffect(() => {
    if (globalcontext.wishListAll) {
      setListItem(globalcontext.wishListAll);
      loadScriptDropDown();
    }
  }, [globalcontext.wishListAll]);

  const handleWishListAdd = (listId) => {
    var param = { listId: listId, productId: productId };
    addToWishList(param);
    if (isAdded) {
      setIsAdded(false);
    } else {
      setIsAdded(true);
    }
  };

  const dropdownId = `proListDropdown-${productId}`;
  const renderWishlistDropdown = (showLabel = false, wrapperClass = "") => (
    <div className={`dropdown proList-dropdown ${wrapperClass}`.trim()} ref={dropdownRef}>
      <button
        type="button"
        className="dropdown-toggle cc-cart-wishlist wishlist wishlistaddedbtn"
        id={dropdownId}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        data-bs-auto-close="outside"
      >
        <span
          className={`wishlist ${isAdded ? "wishlistaddedbtn" : "wishlistremovebtn"} ${isAnimate ? " animate" : ""}`}
        >
          <span className={`wesWishlist ${isAdded ? "wes-whishlist-active" : "wes-whishlist1"}`} />
          {showLabel ? "Add to List" : ""}
        </span>
      </button>
      <div className="dropdown-menu wishlist-dropdown dropdown-menu-lg-end" aria-labelledby={dropdownId}>
        <div className="proList-dropdown-info">
          <h5>Save Product to List</h5>

          <div className="proList-dropdown-content">
            <h6>Select Product List</h6>
            {isValidArray(listItem) && (
              <div className="wishlist-created wishlist-createdList">
                {listItem.map((item, index) => (
                  <div className="wishlist-created-list" key={index}>
                    <p>
                      {item.listName} <small>({item.productCount})</small>
                    </p>
                    <span
                      className="wes-add"
                      onClick={() => {
                        handleWishListAdd(item.listId);
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
            <div className="noWishlist-created">
              <p>No List. Create New List </p>
            </div>
            <div className="proList-dropdown-create">
              <Link to={PAGES.FAVORITEPRODUCT_LIST}>Create New List</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  const renderWishlistDropdownProduct = (showLabel = false, wrapperClass = "") => (
    <>
      <p
        className={`dropdown-toggle cc-cart-wishlist wishlist-products wishlist ${
          isAdded ? "wishlistaddedbtn" : "wishlistremovebtn"
        } ${isAnimate ? " animate" : ""}`}
        id={dropdownId}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        data-bs-auto-close="outside"
      >
        <span className={`wesWishlist ${isAdded ? "wes-whishlist-active" : "wes-whishlist1"}`} />
      </p>
      <div className={`dropdown proList-dropdown`} ref={dropdownRef}>
        <div className="dropdown-menu dropdown-menu-lg-end" aria-labelledby={dropdownId}>
          <div className="proList-dropdown-info">
            <h5>Save Product to List</h5>

            <div className="proList-dropdown-content">
              <h6>Select Product List</h6>
              {isValidArray(listItem) && (
                <div className="wishlist-created wishlist-createdList">
                  {listItem.map((item, index) => (
                    <div className="wishlist-created-list" key={index}>
                      <b>
                        {item.listName} <small>({item.productCount})</small>
                      </b>
                      <span
                        className="wes-add"
                        onClick={() => {
                          handleWishListAdd(item.listId);
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
              <div className="noWishlist-created">
                <b>No List. Create New List </b>
              </div>
              <div className="proList-dropdown-create">
                <Link to={PAGES.FAVORITEPRODUCT_LIST}>Create New List</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  return (
    <Fragment>
      {pageName && (pageName.includes("ORDERDETAILS") || pageName.includes("PENDING-ORDERS"))
        ? renderWishlistDropdown(false)
        : pageName && pageName.includes("ORDER-HISTORY")
          ? renderWishlistDropdown(true, "cart-remove-wishlist orderItem-wishlist")
          : renderWishlistDropdownProduct()}
    </Fragment>
  );
};
